import {Component, Input, OnInit} from '@angular/core';
import {EducationMaterialFile, Group} from "../../../../types/interfaces";
import {ModalController} from "@ionic/angular";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-educational-file',
    templateUrl: './educational-file.component.html',
    styleUrls: ['./educational-file.component.scss'],
})
export class EducationalFileComponent implements OnInit {

    @Input() files: EducationMaterialFile[] | undefined = undefined;

    constructor(private modalCtrl: ModalController, public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {
    }


    openUrl(url: string | undefined) {

        console.log('openUrl', url);

        if (url) {
            this.myGcService.openUrl(url)
        }

    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

}
